module.exports = __webpack_public_path__ + "img/car2.c124af7e.png";